import { Link } from "react-router-dom";
import { categories, getCategoryCount } from "@/lib/movieData";

export default function CategoryStrip() {
  return (
    <section className="bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1180px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-7">
            <div>
              <p className="text-[11px] tracking-[0.3em] text-foreground-400 uppercase">Genre</p>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">按类型找片</h2>
            </div>
            <Link
              to="/category/drama"
              className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览全部片库
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
            {categories.map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="group px-4 py-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/60 transition-colors cursor-pointer"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${category.icon} text-base`}></i>
                </span>
                <p className="mt-4 text-sm font-medium text-foreground-900">{category.type}</p>
                <p className="mt-1 text-[11px] text-foreground-500">
                  {getCategoryCount(category.type)} 部影片
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}